import { BaseAPI } from './base_api';
import { ApiResponse, ProjectFolder } from '@clef/shared/types';

const ProjectFolderAPIUrlPrefix = 'project-folders';

class ProjectFolderAPI extends BaseAPI {
  async list(parentFolderId?: number | null): Promise<ApiResponse<ProjectFolder[]>> {
    const params: Record<string, unknown> = {};
    if (parentFolderId !== undefined) {
      params.parentFolderId = parentFolderId;
    }
    return this.get('', params);
  }

  async getById(id: number): Promise<ApiResponse<ProjectFolder>> {
    return this.get('', { id });
  }

  async create(name: string, parentFolderId?: number | null): Promise<ApiResponse<ProjectFolder>> {
    return this.postJSON('', { name, parentFolderId });
  }

  async update(id: number, name: string): Promise<ApiResponse<ProjectFolder>> {
    return this.postJSON('update', { id, name });
  }

  async deleteFolder(id: number): Promise<ApiResponse<void>> {
    return this.postJSON('delete', { id });
  }

  async move(id: number, parentFolderId: number | null): Promise<ApiResponse<ProjectFolder>> {
    return this.postJSON('move', { id, parentFolderId });
  }

  async moveProject(projectId: number, projectFolderId: number | null): Promise<ApiResponse<void>> {
    return this.postJSON('move-project', { projectId, projectFolderId });
  }
}

export default new ProjectFolderAPI(ProjectFolderAPIUrlPrefix);
